<template>
  <!-- «Оплата обучения» из раздела «Получение лицензий» (правка начальника
       02.10.2026). Та же страница оплаты, что у продления, в режиме
       первичного обучения. Отдельная обёртка нужна, чтобы у двух маршрутов
       были разные компоненты: при переходе между «Оплатой лицензий» и
       «Оплатой обучения» страница создаётся заново и перечитывает список. -->
  <license-payment kind="initial"></license-payment>
</template>

<script>
import LicensePayment from './LicensePayment.vue'

export default {
  components: {
    LicensePayment,
  },
}
</script>
